import numeral from 'numeral'
import 'numeral/locales/fr'
export default numeralConfig

/** @ngInject */
function numeralConfig() {
    // switch between locales
    numeral.locale('fr')
}



// WEBPACK FOOTER //
// ./src/config/numeral.js